let accordionButton = $('.js-mob-accordion');

accordionButton.on('click', function () {
    let block = $(this).parents('.mobile-menu-bottom-block');

    if (!block.hasClass('_expanded')) {
        block.addClass('_expanded');
        block.find('.mobile-menu-bottom-block__body').slideDown(300);
    } else {
        block.removeClass('_expanded');
        block.find('.mobile-menu-bottom-block__body').stop().slideUp(300);
    }
});